import i18n from '../../i18n';

const LandingServicesData = [
    {
        id: 1,
        title: i18n.t('landing_data.services_0_title'),
        points: [i18n.t('landing_data.services_0_point_0'), i18n.t('landing_data.services_0_point_1'), i18n.t('landing_data.services_0_point_2'), i18n.t('landing_data.services_0_point_3')]
    },
    {
        id: 2,
        title: i18n.t('landing_data.services_1_title'),
        points: [i18n.t('landing_data.services_1_point_0'), i18n.t('landing_data.services_1_point_1'), i18n.t('landing_data.services_1_point_2'), i18n.t('landing_data.services_1_point_3')]
    },
    {
        id: 3,
        title: i18n.t('landing_data.services_2_title'),
        points: [i18n.t('landing_data.services_2_point_0'), i18n.t('landing_data.services_2_point_1'), i18n.t('landing_data.services_2_point_2'), i18n.t('landing_data.services_2_point_3')]
    },
    {
        id: 4,
        title: i18n.t('landing_data.services_3_title'),
        points: [i18n.t('landing_data.services_3_point_0'), i18n.t('landing_data.services_3_point_1'), i18n.t('landing_data.services_3_point_2'), i18n.t('landing_data.services_3_point_3')]
    },
    
];

export default LandingServicesData;